interface CategoryItem {
  name: string;
  desc: string;
  url: string;
  imageUrl: string;
  highlight: boolean;
}

const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    desc: 'Curated footwear links',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20close-up%20product%20photography%20of%20a%20pair%20of%20premium%20sneakers%20positioned%20diagonally%20on%20a%20textured%20warm%20sand%20surface%2C%20extremely%20soft%20diffused%20side%20lighting%20from%20a%20large%20window%2C%20visible%20leather%20grain%20and%20stitching%20detail%2C%20subtle%20long%20shadows%2C%20cream%20and%20beige%20minimalist%20aesthetic%2C%20editorial%20fashion%20catalog%20composition%2C%20no%20logos%2C%20serene%20and%20refined%20atmosphere&width=600&height=520&seq=cat-shoes-n1-2026&orientation=landscape',
    highlight: true,
  },
  {
    name: 'Hoodies / Sweaters',
    desc: 'Cozy knitwear selections',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Overhead%20flatlay%20composition%20of%20a%20softly%20folded%20oatmeal%20knit%20sweater%20on%20a%20pale%20linen%20surface%2C%20gentle%20golden%20hour%20sunlight%20casting%20delicate%20leaf%20shadows%20from%20a%20nearby%20plant%2C%20visible%20cable%20knit%20texture%20detail%2C%20warm%20ivory%20and%20sand%20color%20palette%2C%20Scandinavian%20hygge%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20calm%20and%20inviting%20atmosphere%2C%20no%20branding%20visible&width=600&height=520&seq=cat-hoodies-n2-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'T-Shirts',
    desc: 'Essential top picks',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20heavyweight%20cotton%20t-shirt%20draped%20elegantly%20over%20the%20edge%20of%20a%20warm%20wooden%20table%2C%20soft%20morning%20light%20streaming%20from%20the%20left%2C%20visible%20fabric%20weave%20and%20drape%2C%20warm%20earth%20tones%20against%20a%20cream%20plaster%20wall%20background%2C%20editorial%20fashion%20still%20life%2C%20refined%20simplicity%2C%20no%20logos%20or%20graphics&width=600&height=520&seq=cat-tshirts-n3-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Jackets',
    desc: 'Outerwear collection',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20studio%20photograph%20of%20a%20tailored%20denim%20jacket%20hung%20loosely%20on%20a%20vintage%20brass%20hook%20mounted%20on%20a%20warm%20cream%20wall%2C%20soft%20diffused%20overhead%20lighting%2C%20visible%20textile%20weave%20and%20subtle%20distressing%20details%2C%20sand%20and%20indigo%20color%20contrast%2C%20editorial%20fashion%20aesthetic%2C%20clean%20composition%20with%20generous%20negative%20space%2C%20sophisticated%20casual%20vibe&width=600&height=520&seq=cat-jackets-n4-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Pants / Shorts',
    desc: 'Bottom wear finds',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20still%20life%20of%20neatly%20rolled%20chino%20trousers%20placed%20on%20a%20smooth%20warm%20terracotta%20surface%2C%20soft%20natural%20light%20from%20an%20unseen%20window%2C%20visible%20cotton%20twill%20texture%20and%20seam%20detail%2C%20earth%20tone%20color%20harmony%2C%20Scandinavian%20minimalist%20editorial%20style%2C%20serene%20composition%20with%20subtle%20shadow%20play%2C%20no%20brand%20markings&width=600&height=520&seq=cat-pants-n5-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Headwear',
    desc: 'Caps and hats guide',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20structured%20baseball%20cap%20resting%20on%20a%20curved%20stone%20pedestal%20against%20a%20soft%20cream%20backdrop%2C%20gentle%20diffused%20spotlight%20from%20above%2C%20visible%20fabric%20weave%20and%20embroidered%20eyelet%20details%2C%20warm%20neutral%20palette%2C%20minimalist%20sculptural%20aesthetic%2C%20editorial%20sport-luxe%20style%2C%20elegant%20and%20refined%20composition%2C%20no%20visible%20branding&width=600&height=520&seq=cat-headwear-n6-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Sets',
    desc: 'Coordinated outfit sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Graceful%20flatlay%20arrangement%20of%20a%20matching%20set%20of%20clothing%20folded%20in%20neat%20geometric%20shapes%20on%20a%20warm%20ivory%20linen%20surface%2C%20soft%20afternoon%20light%20creating%20gentle%20gradients%2C%20visible%20textile%20textures%20of%20different%20fabric%20weights%2C%20beige%20oatmeal%20and%20sand%20tones%2C%20editorial%20minimalist%20fashion%20composition%2C%20serene%20and%20balanced%20layout%2C%20no%20visible%20logos&width=600&height=520&seq=cat-sets-n7-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Underwear',
    desc: 'Essential basics',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Refined%20product%20still%20life%20of%20organic%20cotton%20undergarments%20folded%20precisely%20and%20stacked%20on%20a%20smooth%20warm%20beige%20surface%2C%20extremely%20soft%20natural%20window%20light%20from%20the%20right%20side%2C%20visible%20fabric%20softness%20and%20gentle%20texture%2C%20cream%20and%20sand%20monochrome%20palette%2C%20minimalist%20editorial%20aesthetic%2C%20clean%20and%20understated%20composition%2C%20premium%20feel%2C%20no%20branding&width=600&height=520&seq=cat-underwear-n8-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Jersey',
    desc: 'Sports jersey collection',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20yet%20clean%20product%20photography%20of%20a%20sleek%20athletic%20jersey%20draped%20over%20a%20minimal%20wooden%20hanger%20suspended%20against%20a%20soft%20cream%20wall%2C%20directional%20studio%20lighting%20emphasizing%20fabric%20drape%20and%20subtle%20sheen%2C%20modern%20sport%20aesthetic%2C%20warm%20neutral%20background%2C%20editorial%20athletic%20wear%20catalog%20style%2C%20clean%20lines%20and%20refined%20composition%2C%20no%20team%20logos%20or%20numbers&width=600&height=520&seq=cat-jersey-n9-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Accessories',
    desc: 'Finishing touches',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artfully%20arranged%20collection%20of%20minimalist%20accessories%20including%20a%20watch%2C%20bracelet%2C%20and%20sunglasses%20placed%20on%20a%20warm%20travertine%20stone%20surface%2C%20soft%20natural%20light%20creating%20elegant%20reflections%20and%20shadows%2C%20cream%20and%20sand%20tones%20with%20subtle%20metallic%20accents%2C%20editorial%20luxury%20still%20life%2C%20Scandinavian%20refinement%2C%20sophisticated%20composition&width=600&height=520&seq=cat-accessories-n10-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Bags',
    desc: 'Bag and backpack links',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20structured%20canvas%20tote%20bag%20standing%20upright%20on%20a%20warm%20wooden%20surface%2C%20soft%20morning%20light%20from%20a%20side%20window%2C%20visible%20canvas%20texture%20and%20leather%20strap%20detail%2C%20cream%20and%20warm%20brown%20color%20palette%2C%20minimalist%20editorial%20style%2C%20clean%20composition%20with%20subtle%20shadow%2C%20refined%20everyday%20luxury%20feel%2C%20no%20visible%20branding&width=600&height=520&seq=cat-bags-n11-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Belts',
    desc: 'Waist accessory picks',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Refined%20still%20life%20of%20a%20premium%20leather%20belt%20coiled%20gracefully%20on%20a%20smooth%20sand-colored%20marble%20surface%2C%20soft%20directional%20lighting%20highlighting%20leather%20grain%20and%20brass%20buckle%20detail%2C%20warm%20neutral%20tones%2C%20minimalist%20luxury%20aesthetic%2C%20editorial%20accessory%20photography%2C%20clean%20elegant%20composition%20with%20gentle%20shadows%2C%20no%20brand%20markings&width=600&height=520&seq=cat-belts-n12-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Perfumes',
    desc: 'Fragrance selections',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20of%20a%20minimalist%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20placed%20on%20a%20cream%20linen%20surface%2C%20soft%20diffused%20backlighting%20creating%20a%20gentle%20glow%20through%20the%20glass%2C%20delicate%20shadow%20play%2C%20warm%20golden%20and%20beige%20tones%2C%20editorial%20beauty%20still%20life%2C%20Scandinavian%20elegance%2C%20serene%20and%20luxurious%20composition%2C%20no%20visible%20labels%20or%20text&width=600&height=520&seq=cat-perfumes-n13-2026&orientation=landscape',
    highlight: false,
  },
  {
    name: 'Other Stuff',
    desc: 'More great finds',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20flatlay%20of%20diverse%20lifestyle%20products%20including%20a%20notebook%2C%20ceramic%20mug%2C%20and%20small%20decorative%20objects%20arranged%20harmoniously%20on%20a%20warm%20oatmeal%20wool%20blanket%20surface%2C%20soft%20natural%20window%20light%20from%20above%2C%20varied%20textures%20of%20paper%20ceramic%20and%20fabric%2C%20cream%20sand%20and%20warm%20gray%20palette%2C%20editorial%20lifestyle%20aesthetic%2C%20serene%20and%20intentional%20composition%2C%20no%20brand%20names%20visible&width=600&height=520&seq=cat-other-n14-2026&orientation=landscape',
    highlight: false,
  },
];

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-14">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-4">
            Browse by Category
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Explore Our Curated
            <br />
            Product <span className="italic text-accent-500">Spreadsheet</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-4 max-w-[480px] leading-relaxed">
            Every category is hand-organized with the best finds. Click any category to open the full spreadsheet on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-2xl h-[260px] cursor-pointer block"
            >
              <img
                src={cat.imageUrl}
                alt={`Superbuy Spreadsheet ${cat.name} category`}
                title={`Superbuy Spreadsheet ${cat.name}`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>

              {cat.highlight && (
                <div className="absolute top-4 left-4 w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border border-white/30">
                  <span className="text-white text-xs font-bold">S</span>
                </div>
              )}

              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white/70 text-[11px] font-medium tracking-wider uppercase mb-1">
                  {cat.desc}
                </p>
                <h3 className="text-white text-lg font-bold font-heading">
                  {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            View All Categories
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}